import React, { FC } from "react";

import { Restricted } from "../../../../components/Restricted";

import { Fields } from "../../../../ui/layout/detailedPages/Fields";
import { FiltersRow } from "./InterfaceFilters/FiltersRow";
import { ObjectDetectionRow } from "./ObjectDetection/ObjectDetectionRow";
import { UpdateCampaignProps } from "../../types";
import { SlideOverFieldNamedRow } from "../../../../ui/layout/organisms/SlideOver/SlideOverFixedLayouts/SlideOverSingleField/SlideOverFieldNamedRow";
import {
  controlledInputTitles,
  preferredImageSettings,
} from "../../../constants";
import { valueOrNA, valueToTitle } from "../../../../helpers";
import { SelectOptionsProps } from "../../../../ui/layout/molecules/types";
import { CampaignNumbericKey } from "../../../components/CampaignNumberic";
import { CampaignEnumKeys } from "../../../types";
import { parseNumberOrZero } from "../../../../helpers";

export const InterfaceControls: FC<UpdateCampaignProps> = ({
  campaign,
  updateCampaignBody,
}) => {
  const campaignType = campaign?.type;
  const isVpsCampaign = campaignType === "VPS";

  const isVpdCampaign = campaignType === "VPD";
  const isTextSearchCampaign = campaign?.type === "TEXT_SEARCH";

  const enableCustomFilters = campaignType === "TEXT_SEARCH" || isVpsCampaign;

  const RenderSlideOverRow = (
    key: CampaignNumbericKey | CampaignEnumKeys,
    options?: SelectOptionsProps,
  ) => {
    const isNumber = !options;
    return (
      <SlideOverFieldNamedRow
        onAccept={(value) =>
          updateCampaignBody({
            [key]: isNumber ? parseNumberOrZero(String(value)) : value,
          })
        }
        namedRowTitle={controlledInputTitles[key]}
        permissionsGroup="campaign:basic_config"
        slideOverValue={campaign?.[key]}
        inputType={isNumber ? "number" : undefined}
        customContent={valueToTitle(`${valueOrNA(campaign?.[key])}`)}
        options={options}
      />
    );
  };

  return (
    <Restricted permissions="campaign:basic_config:view">
      <Fields title="Interface controls">
        {RenderSlideOverRow("preferredImage", preferredImageSettings)}
        {RenderSlideOverRow("maximumResults")}
        {isTextSearchCampaign && (
          <>
            {RenderSlideOverRow("exactSearchMaximumResults")}
            {RenderSlideOverRow("numberOfDisplayedDynamicFilters")}
          </>
        )}

        {isVpsCampaign && (
          <Restricted permissions="campaign:advanced_config:view">
            <ObjectDetectionRow
              campaign={campaign}
              updateCampaignBody={updateCampaignBody}
            />
          </Restricted>
        )}

        {!isVpdCampaign && (
          <FiltersRow
            updateCampaignBody={updateCampaignBody}
            enabledFilterColumns={campaign.enabledFilterColumns}
            initFiltersSorting={campaign.filterSorting}
            enableCustomFilters={enableCustomFilters}
          />
        )}
      </Fields>
    </Restricted>
  );
};
